import React, { useEffect } from 'react';
import bottomImage from "../../Images/Image/botImg.png";
import { HeaderBox } from './mBookListPage';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AudioServices from "../../Services/Audios";
import PravachanServices from "../../Services/Pravachans";

const MbAudioCategory = () => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = React.useState<boolean | null>(false);
  const [authors, setAuthors] = React.useState<any>();
  const [category, setCategory] = React.useState<any>();
  const [selectedMenu, setSelectedMenu] = React.useState<any>("");
  const [selectedItemId, setSelectedItemId] = React.useState<any>("");
  const [recordCounts, setRecordCounts] = React.useState<{ [key: string]: number }>({});
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  const { t } = useTranslation();

  // Fetch authors
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AudioServices.getFilters("audio");
        if (response?.result) {
          setAuthors(response.result.authors);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  // Fetch categories
  useEffect(() => {
    const fetchAudios = async () => {
      try {
        const response = await AudioServices.getAudioCategories(selectedItemId);
        if (response?.result) {
          setCategory(response.result);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchAudios();
  }, [selectedItemId]);

  // Fetch record counts
  useEffect(() => {
    const fetchRecordCount = async () => {
      try {
        const response = await PravachanServices.getRecordCount("categories", "audio", undefined, undefined, selectedItemId || undefined);
        if (response?.result) {
          const counts: { [key: string]: number } = {};
          response.result.forEach((item: any) => {
            counts[item.id] = item.recordCount;
          });
          setRecordCounts(counts);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchRecordCount();
  }, [selectedItemId]);

  // Get record count for a category/subcategory
  const getRecordCount = (item: any): number => {
    if (!item) return 0;
    if (item?.items && Array.isArray(item.items)) {
      return item.items.reduce((sum: number, subItem: any) => {
        return sum + (recordCounts[subItem?.id] || 0);
      }, 0);
    }
    return recordCounts[item?.id] || 0;
  };

  // Total record count for all categories
  const getTotalRecordCount = (): number => {
    return Object.values(recordCounts).reduce((sum, n) => sum + n, 0);
  };

  return (
    <>
      {/* Header */}
      <HeaderBox>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}
        >
          <ArrowBackIos sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton
          onClick={() => navigate("/")}
          sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}
        >
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("Audios_tr")}
        </Typography>
        <img
          src={bottomImage}
          alt="Bottom"
          style={{ width: "100%", position: "fixed", bottom: 0, left: 0, zIndex: -1 }}
        />
      </HeaderBox>

      {/* Presenter Dropdown */}
      <div className='mb-1' style={{ backgroundColor: "white", padding: 5 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#F8EDE1",
            margin: 5,
            padding: 10
          }}
          onClick={() => setOpenMenu(prev => !prev)}
        >
          <div>{selectedMenu || "सभी प्रस्तुतकर्ता"}</div>
          {openMenu
            ? <KeyboardArrowUpIcon sx={{ fontSize: 25, color: "orange" }} />
            : <KeyboardArrowDownIcon sx={{ fontSize: 25, color: "orange" }} />}
        </div>
      </div>

      {/* All Audios as normal category item */}
      <div
        style={{
          borderBottom: '0.2px solid rgba(0,0,0,0.1)',
          padding: 10,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          // justifyContent: "space-between",
          fontFamily: 'chankayaUni',
          fontSize: '14px',
          fontWeight: 600,
          // backgroundColor: selectedItemId === "" ? "#FFF7E6" : "white",
        }}
        onClick={() => {
          setSelectedMenu("सभी ऑडियो");
          setSelectedItemId(""); // reset selected author
          setOpenIndex(null);    // collapse all
          navigate("/audios", { state: { categoryId: "", type: "audios", categoryName: t("all_audios_tr") || "सभी ऑडियो" } });  // ✅ Added navigate call
        }}
      >
        <span style={{ paddingLeft: '18px' }}>सभी ऑडियो</span>
        <span style={{ paddingLeft: 4 }}>({getTotalRecordCount()})</span>
      </div>

      {/* Category List */}
      {category?.map((item: any, index: number) => (
        <div key={item?.id} style={{ borderBottom: '0.2px solid rgba(0,0,0,0.1)', padding: 10 }} >
          <span
            style={{
              paddingLeft: item?.items == null ? "5%" : "",
              fontFamily: 'chankayaUni',
              fontSize: '14px',
              fontWeight: 600,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              // justifyContent: "space-between",
            }}
            onClick={() => setOpenIndex(prev => (prev === index ? null : index))}
          >
            <div style={{ display: "flex", alignItems: "center" }}  >
              {item?.items !== null ? (
                openIndex === index ? (
                  <>
                    <KeyboardArrowDownIcon sx={{ fontSize: 25, color: "orange", mr: 1 }} />
                    <span>{item?.name}</span>
                  </>
                ) : (
                  <>
                    <KeyboardArrowRightIcon sx={{ fontSize: 25, color: "orange", mr: 1 }} />
                    <span>{item?.name}</span>
                  </>
                )
              ) : (
                <span onClick={() => { navigate("/audios", { state: { categoryId: item?.id, type: "audios", categoryName: item?.name } }); console.log(item?.id, "itemitems") }}>{item?.name}</span>
              )}
            </div>
            <span style={{ paddingLeft: 8, fontWeight: 600 }}>
              ({getRecordCount(item)})
            </span>
          </span>

          {/* Subcategories */}
          {openIndex === index && item?.items?.map((innerItem: any, idx: number) => (
            <>

              <div

                key={innerItem.id || idx}
                style={{
                  borderBottom:
                    idx === item.items.length - 1
                      ? 'none'
                      : '0.2px solid rgba(0, 0, 0, 0.1)',
                  padding: 10,
                  fontWeight: 400,
                  color: '#36454F',
                  paddingLeft: 30,
                  fontSize: 18,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span onClick={() => { navigate("/audios", { state: { categoryId: innerItem?.id, type: "audios", categoryName: innerItem?.name } }) }}>{innerItem.name}</span>
                <span style={{ fontWeight: 600, paddingLeft: 5, color: '#36454F' }}>
                  ({getRecordCount(innerItem)})
                </span>
              </div>
            </>
          ))}
        </div>
      ))}

      {/* Dropdown Menu */}
      {openMenu && (
        <div
          style={{
            backgroundColor: "#F8EDE1",
            zIndex: 9999,
            position: "absolute",
            width: "94%",
            left: "3%",
            borderRadius: 2,
            boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
            padding: 10,
            maxHeight: "580px",
            overflowY: "auto",
            top: 150
          }}
          className='scroll-hidden'
        >
          <h5
            style={{ fontWeight: 500, cursor: "pointer" }}
            onClick={() => { setSelectedMenu(""); setSelectedItemId(""); setOpenMenu(false); }}
          >
            सभी प्रस्तुतकर्ता
          </h5>

          {authors?.map((item: any, i: any) => (
            <div
              key={item?.id || item?.name || i}
              style={{ padding: 8, fontSize: 18, fontFamily: "chanakyaUni", cursor: "pointer" }}
              onClick={() => { setSelectedMenu(item?.name); setSelectedItemId(item?.id); setOpenMenu(false); }}
            >
              {item?.name || "Unknown"}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MbAudioCategory;